<template>
	<section class="title-area" :class="{ 'is-dashed' : dashed }">
		<div class="titles ">
			<span>{{title}}</span>
			<span class="hint">{{hint}}</span>
		</div>
		<div class="contents clearfix" :style="{'margin-left': marginLeft + 'px', 'padding-right' : paddingRight + 'px'}">
			<slot></slot>
		</div>
	</section>
</template>

<script>

	export default {
		data() {
			return {

      }
		},

		props: {
			title: String,
			hint: String,
			dashed: {
				type: Boolean,
				default: true
			},
			marginLeft: {
				type:Number,
				default: 89
			},
			paddingRight: {
				type:Number,
				default: 0
			}
		},

		mounted: function() {
			this.$nextTick(function() {

			})
		},

		methods: {

		}
	}
</script>

<style scoped>
.title-area {
	padding-bottom: 20px;
}

.is-dashed {
	border-bottom: 1px dashed #eff3f6;
}

.titles {
	color: #283140;
	font-weight: bold;
	padding: 20px 4px;
}

.titles .hint {
	margin-left: 10px;
	color: #999;
	font-weight: normal;
}

.contents {
}

</style>


// WEBPACK FOOTER //
// title_area.vue?52079c61